import React from "react";

export default function Lightbox({ images, index, onClose, onNav }) {
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onNav(-1);
      if (e.key === "ArrowRight") onNav(1);
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = images ? "hidden" : "";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [images, onClose, onNav]);

  if (!images) return null;
  return (
    <div className="lightbox open" onClick={onClose} data-testid="lightbox">
      <button className="lightbox-close" onClick={onClose} aria-label="Close">×</button>
      <button className="lightbox-prev" onClick={(e) => { e.stopPropagation(); onNav(-1); }} aria-label="Previous">‹</button>
      <img src={images[index]} alt="" />
      <button className="lightbox-next" onClick={(e) => { e.stopPropagation(); onNav(1); }} aria-label="Next">›</button>
    </div>
  );
}
